import { NgModule } from "@angular/core";
import { NgbTimepickerModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { CommonComponentsModule } from "../common/common-components.module";
import { CalendarScheduleOrder } from "./calendar-schedule-order";

@NgModule({
  declarations: [CalendarScheduleOrder],
  imports: [
    IonicPageModule.forChild(CalendarScheduleOrder),
    TranslateModule.forChild(),
    NgSelectModule,
    NgbTimepickerModule,
    CommonComponentsModule,
  ],
  entryComponents: [CalendarScheduleOrder],
  exports: [],
})
export class CalendarScheduleOrderModule {}



// WEBPACK FOOTER //
// ./src/components/calendar-schedule-order/calendar-schedule-order.module.ts